import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1d": "#870087",
    "col1l": "#FF00FF",
    "col1n": "#C600C6",
    "col2d": "#780EE5",
    "col2l": "#B46BFF",
    "col2n": "#9C3AFF"
}
function PlaInd040({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <radialGradient
                    id="PlaInd040__Gradient_14"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={19.499}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(.93981 .3417 -1.73667 4.38814 46.7 183.7)"
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_15"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={28.291}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(.96719 -.25406 .81785 3.20953 280.55 201.7)"
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_16"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={33.765}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(.99326 .11587 -.32615 2.75878 154.4 213.75)"
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_17"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={18.213}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(.87438 -.48523 2.08026 3.82354 377.95 155.7)"
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_18"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={216.525}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .86895 192.85 28)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_19"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={39.9}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .56642 289.45 363.05)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_20"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={27.875}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .58251 210.25 307.15)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_21"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={16.475}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .49469 205.55 271.45)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_22"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={11.275}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .40022 181.5 237.85)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_23"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={11.275}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .40022 207.75 244.65)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_24"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={15.838}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .48382 251.6 258.1)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_25"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={25.962}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .56524 288.9 295.85)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_26"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={11.275}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .40022 251 235.75)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_27"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={11.275}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .40022 283.25 244.65)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_28"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={11.275}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .40022 305.45 235.75)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_29"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={34.213}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .5864 193 347.2)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_30"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={53.25}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .53803 202.55 396.35)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_31"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={42.3}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .56649 113.9 363.95)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_32"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={55.025}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .53794 26.4 394.85)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_33"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={34.213}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .58275 37.5 343.75)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_34"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={34.5}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .56594 97.5 316.25)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_35"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={24.825}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .56647 30 294.45)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_36"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={17.363}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .47516 44.15 265.85)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_37"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={11.275}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .40022 16.65 248.55)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_38"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={11.275}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .40022 44.75 241.9)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_39"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={22.037}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .53885 143.5 280.7)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_40"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={15.838}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .48382 159.9 256.7)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_41"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={15.838}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .48382 83.15 256.7)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_42"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={11.275}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .40022 88.3 239.65)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_43"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={11.275}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .40022 121.75 244.65)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_44"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={53.913}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .5379 381.95 379.6)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_45"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={32.813}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .56 352.15 329.8)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_46"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={20.775}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .56619 357.25 277.8)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_47"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={16.475}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .49469 313.1 263.8)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_48"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={11.275}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .40022 338 239.65)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <radialGradient
                    id="PlaInd040__Gradient_49"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={11.275}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(1 0 0 .40022 364.5 248.55)"
                    spreadMethod="pad"
                >
                    <stop offset="32.941%" stopOpacity={0} />
                    <stop offset="100%" />
                </radialGradient>
                <linearGradient
                    id="PlaInd040__Gradient_1"
                    gradientUnits="userSpaceOnUse"
                    x1={193.2}
                    y1={290.762}
                    x2={193.2}
                    y2={190.537}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopOpacity={0} />
                    <stop offset="100%" />
                </linearGradient>
                <linearGradient
                    id="PlaInd040__Gradient_2"
                    gradientUnits="userSpaceOnUse"
                    x1={370.212}
                    y1={56.863}
                    x2={344.188}
                    y2={71.538}
                    spreadMethod="pad"
                >
                    <stop offset="25.882%" stopOpacity={0} />
                    <stop offset="100%" />
                </linearGradient>
                <linearGradient
                    id="PlaInd040__Gradient_3"
                    gradientUnits="userSpaceOnUse"
                    x1={371.675}
                    y1={55.9}
                    x2={394.725}
                    y2={36.9}
                    spreadMethod="pad"
                >
                    <stop offset="25.882%" stopOpacity={0} />
                    <stop offset="100%" />
                </linearGradient>
                <linearGradient
                    id="PlaInd040__Gradient_4"
                    gradientUnits="userSpaceOnUse"
                    x1={118.6}
                    y1={112.6}
                    x2={147.9}
                    y2={118.4}
                    spreadMethod="pad"
                >
                    <stop offset="25.882%" stopOpacity={0} />
                    <stop offset="100%" />
                </linearGradient>
                <linearGradient
                    id="PlaInd040__Gradient_5"
                    gradientUnits="userSpaceOnUse"
                    x1={303.363}
                    y1={99.525}
                    x2={274.637}
                    y2={107.775}
                    spreadMethod="pad"
                >
                    <stop offset="25.882%" stopOpacity={0} />
                    <stop offset="100%" />
                </linearGradient>
                <linearGradient
                    id="PlaInd040__Gradient_6"
                    gradientUnits="userSpaceOnUse"
                    x1={304.987}
                    y1={98.912}
                    x2={331.813}
                    y2={85.787}
                    spreadMethod="pad"
                >
                    <stop offset="25.882%" stopOpacity={0} />
                    <stop offset="100%" />
                </linearGradient>
                <linearGradient
                    id="PlaInd040__Gradient_7"
                    gradientUnits="userSpaceOnUse"
                    x1={214.425}
                    y1={120.775}
                    x2={243.875}
                    y2={115.825}
                    spreadMethod="pad"
                >
                    <stop offset="25.882%" stopOpacity={0} />
                    <stop offset="100%" />
                </linearGradient>
                <linearGradient
                    id="PlaInd040__Gradient_8"
                    gradientUnits="userSpaceOnUse"
                    x1={212.7}
                    y1={120.888}
                    x2={182.8}
                    y2={120.612}
                    spreadMethod="pad"
                >
                    <stop offset="25.882%" stopOpacity={0} />
                    <stop offset="100%" />
                </linearGradient>
                <linearGradient
                    id="PlaInd040__Gradient_9"
                    gradientUnits="userSpaceOnUse"
                    x1={116.925}
                    y1={112.075}
                    x2={89.075}
                    y2={101.225}
                    spreadMethod="pad"
                >
                    <stop offset="25.882%" stopOpacity={0} />
                    <stop offset="100%" />
                </linearGradient>
                <linearGradient
                    id="PlaInd040__Gradient_10"
                    gradientUnits="userSpaceOnUse"
                    x1={3.313}
                    y1={20.65}
                    x2={-21.613}
                    y2={4.15}
                    spreadMethod="pad"
                >
                    <stop offset="25.882%" stopOpacity={0} />
                    <stop offset="100%" />
                </linearGradient>
                <linearGradient
                    id="PlaInd040__Gradient_11"
                    gradientUnits="userSpaceOnUse"
                    x1={43.15}
                    y1={79.125}
                    x2={71.25}
                    y2={89.075}
                    spreadMethod="pad"
                >
                    <stop offset="25.882%" stopOpacity={0} />
                    <stop offset="100%" />
                </linearGradient>
                <linearGradient
                    id="PlaInd040__Gradient_12"
                    gradientUnits="userSpaceOnUse"
                    x1={4.8}
                    y1={21.512}
                    x2={32.2}
                    y2={33.388}
                    spreadMethod="pad"
                >
                    <stop offset="25.882%" stopOpacity={0} />
                    <stop offset="100%" />
                </linearGradient>
                <linearGradient
                    id="PlaInd040__Gradient_13"
                    gradientUnits="userSpaceOnUse"
                    x1={41.575}
                    y1={78.362}
                    x2={15.625}
                    y2={63.837}
                    spreadMethod="pad"
                >
                    <stop offset="25.882%" stopOpacity={0} />
                    <stop offset="100%" />
                </linearGradient>
                <path
                    fill={colors.col1n}
                    d="M390.45 390.45V0H0v390.45h390.45z"
                    id="PlaInd040__Symbol_102_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1l}
                    d="M0 68.25q0 8.35 8.25 14.2t19.9 5.85q11.7 0 19.95-5.85 8.2-5.85 8.2-14.2 0-8.3-8.2-14.2-8.25-5.85-19.95-5.85-11.65 0-19.9 5.85Q0 59.95 0 68.25m98.65-38.8q0-4.6-5.9-7.9-5.85-3.25-14.2-3.25T64.3 21.55q-5.85 3.3-5.85 7.9 0 4.65 5.85 7.85 5.9 3.3 14.25 3.3t14.2-3.3q5.9-3.2 5.9-7.85m131.45 89.5q0-8.3-11.7-14.2-11.65-5.85-28.2-5.85-16.55 0-28.25 5.85-11.65 5.9-11.65 14.2 0 8.35 11.65 14.2 11.7 5.85 28.25 5.85t28.2-5.85q11.7-5.85 11.7-14.2m14.85-51.45q0 8.35 11.65 14.2 11.7 5.85 28.25 5.85t28.2-5.85q11.7-5.85 11.7-14.2 0-8.3-11.7-14.2-11.65-5.85-28.2-5.85-16.55 0-28.25 5.85-11.65 5.9-11.65 14.2m1.25-53.2q8.35 0 14.2-2.1 5.9-2.1 5.9-5.05 0-2.95-5.9-5.05Q254.55 0 246.2 0t-14.25 2.1q-5.85 2.1-5.85 5.05 0 2.95 5.85 5.05 5.9 2.1 14.25 2.1m132.05 6.1q0-4.6-4.75-7.9-4.75-3.25-11.5-3.25-6.7 0-11.45 3.25-4.75 3.3-4.75 7.9 0 4.65 4.75 7.85 4.75 3.3 11.45 3.3 6.75 0 11.5-3.3 4.75-3.2 4.75-7.85z"
                    id="PlaInd040__Symbol_104_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1d}
                    d="M19.45 0Q11.4 0 5.7 3.3 0 6.65 0 11.35q0 4.7 5.7 8 5.7 3.35 13.75 3.35t13.75-3.35q5.7-3.3 5.7-8T33.2 3.3Q27.5 0 19.45 0m176.5 26.85q5.9-3.2 5.9-7.85 0-4.6-5.9-7.9-5.85-3.25-14.2-3.25T167.5 11.1q-5.85 3.3-5.85 7.9 0 4.65 5.85 7.85 5.9 3.3 14.25 3.3t14.2-3.3m95.75 65.4q-12.2-6.9-29.4-6.9t-29.45 6.9q-12.2 7-12.2 16.9 0 9.9 12.2 16.75 12.25 7 29.45 7t29.4-7q12.25-6.85 12.25-16.75t-12.25-16.9z"
                    id="PlaInd040__Symbol_105_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M221 289.2q-2.75-.8-5.75-1.45h-10.6q-10.8.95-18.4 7.75-6.5 5.85-6.5 11 0 2.9.95 6 1.1 2.55 2.6 5.5 3.95 7.75 20.8 10.55 2.55.4 5.25.85h12.15q12.55-4.25 17.7-8.95 4.55-4.2 4.55-10.2 0-4.6-2.25-9.6-.9-1.2-2-2.25-3-2.9-7.7-5.25-4.65-1.8-10.8-3.95m.2-47.45q-3.05-3.75-10.5-3.75-5.6 0-9.95 3.6-3.5 2.95-3.5 4.95 0 4.95 5.15 8.25.45.3 1.05.65 1.5.15 3.2.2H213q5.35-.8 8.05-3.05 1.95-2.6 1.95-5.35 0-3.3-1.8-5.5m79.3 4.55q0-.8-.35-1.7-3.85-2.4-11.55-4.75-4.4-1.35-9.2-.35-.95.65-2.2 1.4-4.75 2.75-9.3 4.1-.95.25-6.4 1.2-1.8.3-4.05.65-9.2 1.5-9.7 1.65-6.1 1.7-10.9 5.8-3.85 3.65-3.85 8 0 6.5 7.75 9.6.55.25 1.3.5h12.6q2.5-.45 6.25-1.05 2.4-.95 6-2.35 4.5-1.75 6-4.4.85-2.9 1.35-4.1 1.2-2.9 4.15-4.4 2.1-1.05 5.05-1.4 3.75-.4 9.45-.45 4.2-1.1 6.2-3.9 1.4-1.95 1.4-4.05m-159.6 84.4q-.6-1.6-.85-3.45-.05.5-.05.85 0 1.2.9 2.6m-77.75-31.55q.75-1 1.7-1.85-.45.15-.8.3l-.8 1.3q-.05.1-.1.25m-62.2-58q-.5-.2-.95-.4v.85q.45-.25.95-.45m60.6 3.25q.2-1.3.2-2.85-3.15-4.05-10.2-4.05-11.4 0-19.7 2.45-3 1.15-4.95 1.8-2.25.7-3.15.75-5.2.1-9.45.6Q2 246.3 2 252.2q0 2.15 1.35 3.65 2.65 1.2 7.05 1.8l6.4.1q5.55-.55 12.35-2.7 5.4-1.75 8.9-2.75 3.55-1.05 5.05-1.3 3.45-.55 8.65-.9 4.35-.3 5.75-.7.85-.2 1.5-.65 1.3-1.85 2.55-4.35M109 294.75H96.9q-14.8-.25-25.25 8.05-4.05 3.2-6.45 7-2.2 3.45-2.2 6 0 8.6 9.25 15.55 5.35 4 6.35 5 2.9 2.9 2.9 6.15 0 4.15-2.45 7.05-4.15 4.8-6.2 8.95-.9 1.9-3.3 10.95-.25.9-.6 1.65-1.35 2.65-4.45 2.65-.55 0-13.85-3.8-8.4-2.4-14.45-3.7L20.75 365h-6.6q-6.55.25-8.75.45-.45.05-3.8.55-.4.05-1.6.6v23.85h133.95q5.6-2.7 9.05-4.6 17-9.25 17-19.45 0-2.2-.25-4.2-2.8-6.45-4.55-11.15-2.75-3.7-7.7-7.5-6.95-5.3-8.4-6.65l-.2-.2q-3.9-4-3.9-8.65 0-2.6 1-6.55 1-3.9 1-6.55 0-4-2.45-8.45l-.05-.05q-2.1-1.85-4.45-3.65-1.85-1.4-3.75-2.7-3.8-1.7-8.35-3.05-1.4-.4-8.95-2.3m31.75-53.1q-3.3-1.6-7.95-3-4.2-1.25-7.05-1.65h-6.85q-4.6.65-7.8 3.05-3.1 2.3-3.1 4.95 0 2.1.9 3.9.75 1.5 2.75 3.95 1.25 1.55 10.15 2.7 4.55.6 9.7 1.2 1.5.6 3.05 1.45 1.8.95 3.7 2.2 1.95 1.3 5.55 3.9 3.15 2.1 6.6 3.2 2 .35 4.3.65 1.85.25 3.55.5 13.85-.05 21-5.75.9-.7 1.65-1.45.1-.9.1-1.85 0-6.45-9.05-10.05-3.65-.4-6.15-.65-6.6-.7-11.9-1.9-1.95-.45-4.1-1.25-.9-.35-1.85-.75-2.1-.85-7.2-3.35M293.1 0h-59.4L244 30.15l75.6 189.1q78.524 19.216 61.8-22.8Q341.04 96.014 293.1 0M177.95 13.4L176.2 0h-56.55l-60 214.2q21.685 8.416 63.5 11.8l54.8-212.6m164.7 286.8q-.1.2-.25.4.2-.05.45-.1l-.2-.3m9.1-37.8q-2.35.85-6.65 3.2-1.7 1.3-2.85 2.15-1.1 1.1-2.8 3.1-.4.5-.75.9-.7 2.75-.7 5.95 0 3.8.75 7.65 1.25 1.9 4.9 6.75 4.3 5.85 4.35 8.65v.05q0 2.65-1.95 3.75-1.15.65-5.05 1.35-9.6 1.8-15.25 7.35-5.2 5.05-6.45 7.8-1.05 2.2-1.05 7.1 0 9.55 7.25 17.05 2.7 1.3 4.05 2.2 4.1 2.75 9.6 8.6l1.1 1.2q.05.05.15.2l-.1.15q.7 1.15.7 2.15 0 2.4-1.75 3.75-3.4 2.65-5.25 5.05-3.05 3.9-4.5 8.65-.65 2.2-2.05 10.05-.45 1.9-.9 3.25h63.9v-122.1q-3-3-3.45-3.35-2.4-1.75-6.3-2.75-4.5-.95-6.95-1.75H361.9q-6.2.5-10.15 1.9M346 231.5h-6.85q-3.35-.1-6.6.85-10.6 5.8-11.2 7.65-.05.1-.05.2 0 .25.25.4-.15.2-.25.45.2 3.6 4.2 6.4 5.35 3.7 15.2 3.7 4.8 0 9.45-2.45 2.35-1.2 4.1-2.55 1.05-.35 2.2-.8 4.8-3.2 4.8-5.45 0-1.7-6.05-5.5-.45-.3-.9-.55-4.2-1.2-8.3-2.35z"
                    id="PlaInd040__Symbol_103_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2l}
                    d="M54.6 105q0 4.15-2.45 7.05-4.15 4.8-6.2 8.95-.9 1.9-3.3 10.95-.25.9-.6 1.65l14.3 19.35h50.7q5.6-2.7 9.05-4.6 17-9.25 17-19.45 0-2.2-.25-4.2-2.8-6.45-4.55-11.15-2.75-3.7-7.7-7.5-6.95-5.3-8.4-6.65L54.6 105M34.85 4.05Q31.7 0 24.65 0q-11.4 0-19.7 2.45-3 1.15-4.95 1.8L11.15 14.8q3.55-1.05 5.05-1.3 3.45-.55 8.65-.9 4.35-.3 5.75-.7.85-.2 1.5-.65 1.3-1.85 2.55-4.35.2-1.3.2-2.85M154.1 22.1q0-6.45-9.05-10.05-3.65-.4-6.15-.65-6.6-.7-11.9-1.9-1.95-.45-4.1-1.25L107.65 20.7q1.8.95 3.7 2.2 1.95 1.3 5.55 3.9 3.15 2.1 6.6 3.2 2 .35 4.3.65 1.85.25 3.55.5 13.85-.05 21-5.75.9-.7 1.65-1.45.1-.9.1-1.85M261.7 2.35Q257.3 1 252.5 2q-.95.65-2.2 1.4-4.75 2.75-9.3 4.1-.95.25-6.4 1.2l16.9 9.9q2.1-1.05 5.05-1.4 3.75-.4 9.45-.45 4.2-1.1 6.2-3.9 1.4-1.95 1.4-4.05 0-.8-.35-1.7-3.85-2.4-11.55-4.75m101.85 109.9V70.6l-42.45-7.35v.05q0 2.65-1.95 3.75-1.15.65-5.05 1.35-9.6 1.8-15.25 7.35-5.2 5.05-6.45 7.8-1.05 2.2-1.05 7.1 0 9.55 7.25 17.05 2.7 1.3 4.05 2.2 4.1 2.75 9.6 8.6l51.3-6.25z"
                    id="PlaInd040__Symbol_108_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2d}
                    d="M32.45 15.6q5.6-2.7 5.6-6.45 0-3.8-5.6-6.45Q26.9 0 19 0 11.15 0 5.6 2.7 0 5.35 0 9.15q0 3.75 5.6 6.45 5.55 2.65 13.4 2.65 7.9 0 13.45-2.65M84.2 86.15q9.5 6.25 22.9 6.25 13.4 0 22.9-6.25 9.5-6.2 9.5-15T130 56.1q-9.5-6.2-22.9-6.2-13.4 0-22.9 6.2-9.5 6.25-9.5 15.05t9.5 15m188.2-53.8q-7.15-4.45-17.25-4.45t-17.3 4.45q-7.15 4.5-7.15 10.8 0 6.3 7.15 10.75 7.2 4.5 17.3 4.5 10.1 0 17.25-4.5 7.2-4.45 7.2-10.75t-7.2-10.8z"
                    id="PlaInd040__Symbol_107_0_Layer0_0_FILL"
                />
                <path
                    fill="url(#PlaInd040__Gradient_1)"
                    d="M388.45 354.95V219H-2v135.95h390.45z"
                    id="PlaInd040__Layer2_0_FILL"
                />
                <path
                    d="M247.45 125.45q3.687-11.807 10.2-13.5 8.505-2.201 20.7 13.2l-42.5-115.3 11.6 115.6m-81.95-3.1q9.082.686 14.85 11.9-.626-49.912-6.15-104.6L147.3 132.8q9.129-11.14 18.2-10.45M337.55 92.8q1.049-4.138 4.4-5.7 3.36-1.521 20.25 13-29.376-42.954-53.3-77.1l28.65 69.8M117.65-1.9h-1.15Q88.842 48.628 61.15 114.95 75.41 98.327 79.4 99.4q4.043 1.082 4.8 10.35Q104.8 53.019 117.65-1.9z"
                    id="PlaInd040__Layer2_1_MEMBER_0_FILL"
                />
                <path
                    d="M388.45 101.95q-15.55 29.85-44.5 55.1-62.55 54-151.1 54-18.65 0-36.1-2.4-11.3-1.55-22.1-4.1-.047-.01-.1-.05-51.737-12.232-92.75-47.45-28.4-24.9-43.8-54.3v268.1q11.95-4.05 27-4.05 16.6 0 29.45 4.9 3.65 1.45 7 3.3 6.45 3.45 10.15 7.5 1.25 1.35 2.25 2.85.45.7.85 1.4.45.85.8 1.7l38.4.05h1q1.393 0 2.75-.05h35.1q.4-.7.85-1.4.95-1.5 2.2-2.85 3.7-4.05 10.1-7.5 15.15-8.2 36.5-8.2 16.6 0 29.45 4.9 3.65 1.45 7 3.3 6.45 3.45 10.15 7.5 1.25 1.35 2.25 2.85.45.7.85 1.4h80.85q-2.4-4-2.4-8.6 0-11.5 15.1-19.55 15.15-8.2 36.5-8.2 3.2 0 6.3.2V101.95m-23.95 142.7q4.496.004 7.65 1.2 2.877 1.162 2.95 2.7-.009.623-.45 1.15v.05q-.747.8-2.5 1.45v.05q-3.167 1.306-7.65 1.3-1.074-.001-2.05-.1-3.178-.248-5.65-1.25h.05q-1.72-.661-2.5-1.5-.444-.525-.45-1.15.073-1.538 2.9-2.7 2.46-.95 5.6-1.15 1.013-.05 2.1-.05m-36.65-3.85q-.444-.525-.45-1.15.077-1.533 2.9-2.65 2.463-.948 5.6-1.2 1.013-.05 2.1-.05 4.496.005 7.65 1.25 2.873 1.117 2.95 2.65-.009.623-.45 1.15v.05q-.747.8-2.5 1.45v.05q-3.167 1.306-7.65 1.3-1.074-.001-2.05-.1-3.178-.248-5.65-1.25h.05q-1.72-.661-2.5-1.5m.5 23q-.117 2.737-4.25 4.8-4.551 2.2-11 2.2-6.45 0-11.1-2.2h.05q-4.04-2.06-4.15-4.8.11-2.74 4.15-4.8H302q4.65-2.201 11.1-2.2 6.449 0 11 2.2 4.133 2.063 4.25 4.8m14.95 21.3q-5.412-2.992-5.5-7.3.09-4.259 5.5-7.3 5.794-3.296 13.95-3.3 8.204.005 13.95 3.3 5.469 3.042 5.55 7.3-.079 4.307-5.55 7.3-5.746 3.296-13.95 3.3-8.156-.003-13.95-3.3m40.2 44.7v.15q-.218 6.9-9 11.75-9.244 5.199-22.35 5.2-13.07 0-22.45-5.2h.05q-1.173-.65-2.2-1.35-6.695-4.49-6.75-10.55.091-6.961 8.95-11.95 9.342-5.199 22.4-5.2 13.106.002 22.35 5.2 8.92 4.99 9 11.95m-254.3-87.4q2.494 1.014 2.65 2.25-.006.465-.35.85l.05-.05q-.7.777-2.35 1.4-3.071 1.3-7.45 1.3-1.048-.003-2-.1h-.05q-3.055-.234-5.45-1.2-1.554-.622-2.25-1.4v.05q-.338-.4-.35-.85.156-1.236 2.6-2.25 2.383-.913 5.45-1.1.976-.05 2.05-.05 4.393-.004 7.5 1.15h-.05m-42.9.65h-.05q-3.055-.234-5.45-1.2-1.554-.622-2.25-1.4v.05q-.338-.4-.35-.85.15-1.227 2.6-2.2 2.385-.912 5.45-1.15.976-.05 2.05-.05 4.38-.002 7.45 1.2h.05q2.45.973 2.6 2.2-.006.465-.35.85l.05-.05q-.7.777-2.35 1.4-3.071 1.3-7.45 1.3-1.048-.003-2-.1m7.6 18.5q-4.432 2.15-10.75 2.15-1.524 0-2.95-.1-4.45-.39-7.9-2.05-2.442-1.178-3.5-2.7-.746-1.01-.75-2.15.06-2.867 4.25-4.95 3.44-1.606 7.85-2 1.463-.1 3-.1 6.319-.001 10.75 2.1 4.288 2.084 4.35 4.95.002 1.153-.7 2.15-1.106 1.51-3.65 2.7m63.05 2.05q-4.45-.39-7.9-2.05-2.442-1.178-3.5-2.7-.746-1.01-.75-2.15.06-2.867 4.25-4.95 3.449-1.61 7.9-2 1.426-.1 2.95-.1 6.319-.001 10.75 2.1 4.288 2.084 4.35 4.95.002 1.153-.7 2.15-1.106 1.51-3.65 2.7-4.432 2.15-10.75 2.15-1.524 0-2.95-.1M133 289.85l.05.05q-2.357-.72-4.45-1.85-5.705-3.045-5.8-7.35.093-4.354 5.8-7.45 6.18-3.302 14.9-3.3 8.718-.001 14.8 3.3 5.85 3.098 5.95 7.45-.102 4.303-5.95 7.35-5.399 2.962-12.85 3.25l-2 .05H143q-4.614-.004-8.5-1.05l-1.5-.45M42.65 238h2.1q4.496.004 7.65 1.2 2.877 1.162 2.95 2.7 0 .62-.45 1.1-.721.886-2.5 1.55-3.154 1.295-7.65 1.3-1.073 0-2.05-.05-3.178-.248-5.65-1.25h.05q-1.719-.663-2.5-1.55-.44-.494-.45-1.1.073-1.538 2.9-2.7 2.453-.944 5.6-1.2m-26 6.65q4.496.004 7.65 1.2 2.877 1.162 2.95 2.7-.009.623-.45 1.15v.05q-.747.8-2.5 1.45v.05q-3.167 1.306-7.65 1.3-1.074-.001-2.05-.1-3.178-.248-5.65-1.25H9q-1.72-.661-2.5-1.5-.444-.525-.45-1.15.073-1.538 2.9-2.7 2.46-.95 5.6-1.15 1.013-.05 2.1-.05m15.6 15.9q3.787-1.76 8.7-2.15 1.526-.149 3.2-.15 6.968-.001 11.85 2.3 4.684 2.235 4.75 5.3-.066 3.065-4.75 5.3-4.882 2.301-11.85 2.3-1.673 0-3.2-.1-4.9-.391-8.7-2.2-4.634-2.235-4.7-5.3.066-3.065 4.7-5.3m-25.7 33.9q.086-5.212 6.65-8.95 6.993-3.898 16.8-3.9 9.855.002 16.8 3.9 6.61 3.74 6.7 8.95-.08 5.208-6.7 8.85-6.945 3.996-16.8 4-9.807-.003-16.8-4-6.561-3.641-6.65-8.85M74 328.9q-8.437-4.731-9.35-11.25-.096-.71-.1-1.4.086-7.462 9.45-12.8 9.793-5.547 23.5-5.55 13.854.004 23.55 5.55 9.412 5.338 9.5 12.8-.004.69-.1 1.4-.915 6.518-9.4 11.25-9.696 5.547-23.55 5.55-13.707-.002-23.5-5.55m-13.15 1.8q9.323 5.483 9.4 13.05-.015 5.24-4.4 9.35-2.054 1.945-5 3.6v.05q-7.429 4.381-17.2 5.35-3.001.298-6.15.3-13.606-.006-23.35-5.7-7.373-4.223-8.95-9.85v-.05q-.395-1.444-.4-3.05.075-7.58 9.35-13.05 9.743-5.546 23.35-5.55 3.162.002 6.15.25 9.781 1.034 17.2 5.3m53.05 55.8l-3.65-.1q-14.598-.645-25.3-6.7-11.66-6.49-11.75-15.75.089-9.261 11.75-15.85 11.994-6.797 28.95-6.8 16.956.003 28.95 6.8 11.71 6.59 11.8 15.85-.08 9.26-11.8 15.75-4.796 2.775-10.45 4.4-7.865 2.403-17.5 2.4h-1m46.55-37.25q-.155-.99-.15-2.05.072-7.631 9.35-13.15 9.695-5.644 23.35-5.65 13.654-.006 23.3 5.65 9.374 5.52 9.45 13.15.005 1.06-.2 2.05-1.167 6.353-9.25 11v.05q-1.564.924-3.3 1.75l.05-.05-2.5 1.05h.05q-7.598 2.954-17.35 2.95h-.15l-12.1-1.3q-6.224-1.426-11.35-4.45-8.03-4.648-9.2-11m137.3-116.15h.05q1.744-.717 3.85-1 .85-.148 1.7-.2 1.013-.05 2.1-.05 1.91.003 3.6.25h.05q1.584.193 2.95.65h.05q.549.176 1 .35 1.379.543 2.1 1.15v-.05q.83.712.85 1.55-.009.623-.45 1.15v.05q-.747.8-2.5 1.45v.05q-2.915 1.208-7 1.3H305.45q-1.074-.001-2.05-.1-3.178-.248-5.65-1.25h.05q-1.72-.661-2.5-1.5-.223-.263-.35-.55-.096-.288-.1-.6.077-1.533 2.9-2.65m-4.35 12.7v.05q-.747.8-2.5 1.45v.05q-3.167 1.306-7.65 1.3-1.074-.001-2.05-.1-3.178-.248-5.65-1.25h.05q-1.72-.661-2.5-1.5-.444-.525-.45-1.15.073-1.538 2.9-2.7 2.46-.95 5.6-1.15 1.013-.05 2.1-.05 4.496.004 7.65 1.2 2.877 1.162 2.95 2.7-.009.623-.45 1.15m-34.75-12.7q2.873 1.117 2.95 2.65-.009.623-.45 1.15v.05q-.747.8-2.5 1.45v.05q-3.167 1.306-7.65 1.3-1.074-.001-2.05-.1-3.178-.248-5.65-1.25h.05q-1.72-.661-2.5-1.5-.444-.525-.45-1.15.077-1.533 2.9-2.65h.05q1.744-.717 3.85-1 .85-.148 1.7-.2 1.013-.05 2.1-.05 1.96.003 3.6.25 2.255.295 4.05 1m8.05 25q.001.8-.35 1.6v-.05q-.914 1.842-4 3.35-4.432 2.15-10.75 2.15-6.319 0-10.85-2.15-2.988-1.508-3.9-3.35v.05q-.352-.8-.35-1.6.06-2.818 4.25-4.9 4.531-2.15 10.85-2.15 6.318 0 10.75 2.15 4.287 2.083 4.35 4.9m4.6 28.3h-.05q7.38-4.05 17.65-4.05 10.355.002 17.6 4.05 6.962 3.986 7.05 9.45-.082 5.41-7.05 9.25-7.246 4.147-17.6 4.15-10.258-.002-17.6-4.15-6.861-3.838-6.95-9.25.082-5.466 6.95-9.45m-55.9-44.45q2.877 1.162 2.95 2.7-.009.623-.45 1.15v.05q-.747.8-2.5 1.45v.05q-3.167 1.306-7.65 1.3-1.074-.001-2.05-.1-3.178-.248-5.65-1.25h.05q-1.72-.661-2.5-1.5-.444-.525-.45-1.15.073-1.538 2.9-2.7 2.46-.95 5.6-1.15 1.013-.05 2.1-.05 4.496.004 7.65 1.2m-36-7.95q1.013-.05 2.1-.05 4.496.004 7.65 1.2 2.877 1.162 2.95 2.7-.009.623-.45 1.15v.05q-.747.8-2.5 1.45v.05q-3.167 1.306-7.65 1.3-1.074-.001-2.05-.1-3.178-.248-5.65-1.25h.05q-1.72-.661-2.5-1.5-.444-.525-.45-1.15.073-1.538 2.9-2.7 2.46-.95 5.6-1.15m15.1 42.2q-4.084-2.06-4.2-4.75.114-2.782 4.2-4.8 4.613-2.249 11.05-2.25 6.436.002 11 2.25 4.086 2.018 4.2 4.8-.116 2.69-4.2 4.75-4.551 2.2-11 2.2-6.45 0-11.1-2.2h.05m-3.2 20.45q7.894-4.545 18.95-4.55 11.105.006 18.95 4.55 7.475 4.385 7.55 10.5-.079 6.017-7.55 10.35-7.845 4.594-18.95 4.6-11.056-.005-18.95-4.6v.05q-7.424-4.37-7.5-10.4.073-6.129 7.5-10.5m120.2 48.9q2.747 1.19 5.25 2.65 10.972 6.14 11.05 14.85-.08 8.707-11.05 14.75-10.053 5.754-23.85 6.4l-3.5.1h-.85q-9.135.003-16.6-2.3l-2.25-.7q-4.032-1.42-7.6-3.5h-.05q-1.185-.604-2.3-1.4-8.59-5.644-8.65-13.35.088-8.71 11-14.85 11.344-6.496 27.35-6.5 12.438-.001 22.05 3.85z"
                    id="PlaInd040__Layer1_0_FILL"
                />
                <path
                    fill="url(#PlaInd040__Gradient_18)"
                    d="M343.95 158.55q28.95-25.25 44.5-55.1V-2H-2v106.25q15.4 29.4 43.8 54.3 41 35.2 92.75 47.5h.1q10.8 2.55 22.1 4.1 17.45 2.4 36.1 2.4 88.55 0 151.1-54z"
                    id="PlaInd040__Layer1_1_FILL"
                />
                <g id="PlaInd040__Layer2_1_FILL">
                    <path
                        fill="url(#PlaInd040__Gradient_2)"
                        d="M327.45-1.9H291.7l59.9 90.55q.267.172.5.35.55.4 1.1.85 4.299 3.604 7.3 9.65 3.055 6.086 9.05 13.6 5.992 7.524 12.05 14.55 6.104 7.015 6.6 7.85.125.214.25.4V83.8l-61-85.7z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_3)"
                        d="M388.45-1.9h-61l61 85.7V-1.9z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_4)"
                        d="M171.95-1.9H147.3L89 211.2l11.3 3.3h21.45q.012-.125 0-.25.033-.125.05-.25-.004-.125 0-.25.006-.075 0-.15.019-.05 0-.1.165-1.81.4-3.65.15-1.35.4-2.7 4.4-36.4 16.4-61.3 3.75-7.75 7.55-13l1.15-1.6 26.5-96.85-2.25-36.3z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_5)"
                        d="M261.5-1.9h-30.45l6.55 18 10.3 107.35q-.012.126-.05.25-.862 2.794-1.45 6.25l-1.35 13.3q-.3 6.838 0 14.2l3.4 29.35q1.595 9.352 4 19.35.3 1.35.65 2.7.575 2.342 1.15 4.65.042.05.05.1.03.075.05.15h.75q-.02-.075-.05-.15-.008-.05-.05-.1-.59-2.325-1.15-4.65-.35-1.35-.65-2.7-2.4-10-3.95-19.35l-3.4-29.35q-.35-7.35-.05-14.2l1.35-13.3q.6-3.45 1.45-6.25.05-.1.1-.25 3.05-9.8 9.2-11.5 8.2-2.2 18.25 10.7 3.45 4.4 7.05 10.55 13.8 23.35 22.9 58.75.3 1.3.65 2.65 1.05 4.25 2 8.35.4 1.95.85 3.85.674 3.37 1.3 6.7.01.05 0 .1.036.075.05.15h1.75l.05.25q.01.05 0 .1.036.075.05.15l.05.25h47.1L352 198.65q-4.996-1.488-10.8-3.4L261.5-1.9z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_6)"
                        d="M291.7-1.9h-30.2l79.7 197.15q5.804 1.912 10.8 3.4l7.95 15.85h28.5v-1.95l-1-1.95v2l-5.2-10.85q.25-.65.2-1.5-4.45-8.1-8-14.65-.15-.25-.25-.45-6.3-11.65-9.95-18.45-.85-1.65-1.55-3l-1-2q-14.1-27.35-19.95-49.25Q337.9 98 339 91.3q.65-3.9 2.9-5.2 3.52-2.025 9.7 2.55L291.7-1.9z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_7)"
                        d="M231.05-1.9H200.2l20.7 216.4h33.65q-.033-.125-.1-.25-.008-.125-.05-.25-.02-.125-.05-.25-.02-.075-.05-.15-.008-.05-.05-.1-.575-2.308-1.15-4.65-.35-1.35-.65-2.7-2.405-9.998-4-19.35l-3.4-29.35q-.3-7.362 0-14.2l1.35-13.3q.588-3.456 1.45-6.25.038-.124.05-.25L237.6 16.1l-6.55-18z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_8)"
                        d="M200.2-1.9h-28.25l2.25 36.3-26.5 96.85-1.15 1.6q-3.8 5.25-7.55 13-12 24.9-16.4 61.3-.25 1.35-.4 2.7-.235 1.84-.4 3.65.019.05 0 .1.006.075 0 .15h.75q.03-.075 0-.15.043-.05.05-.1.101-1.825.35-3.65.15-1.35.4-2.7 4.4-36.4 16.4-61.3 3.75-7.75 7.55-13 .6-.8 1.2-1.55 8.25-10.7 16.9-9.65 8.4 1 13.95 12.65 3.25 6.7 5.6 17 5.888 26.57 2.4 62.2.02.05 0 .1.007.075 0 .15h1.2q.013.125 0 .25-.012.125-.05.25.013.125 0 .25h32.4L200.2-1.9z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_9)"
                        d="M147.3-1.9h-29.65L84.2 106q.144 1.26.2 2.7l-.95 13.45q-.3 2.682-.8 5.65-4.55 26.05-17.25 59.85-.45 1.25-.95 2.5-2.4 6.3-4.85 12.2-2.379 5.764-4.8 11.15-.018.05-.05.1-.016.075-.05.15-.056.125-.1.25-.069.125-.15.25-.044.125-.1.25h45.95L89 211.2 147.3-1.9z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_10)"
                        d="M-2-1.9v31.05L14.2-1.9H-2z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_11)"
                        d="M116.5-1.9h-39L1.65 163.8l-2.3 4.35-1.35-.6v46.95h17.35q.036-.125.05-.25h1.95q.034-.125.05-.25.047-.125.05-.25.046-.075.05-.15.034-.05.05-.1 4.26-15.377 10.8-32.85.8-2.2 1.65-4.4l1-2.5q13.05-33.703 23.55-49.7 10.497-15.946 11.3-17.15.441-.656.5-.8.612-.73 1.2-1.4.068-.079.1-.15L116.5-1.9z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_12)"
                        d="M54.3-1.9H14.2L-2 29.15v76.9L54.3-1.9z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_13)"
                        d="M77.5-1.9H54.3L-2 106.05v61.5l1.35.6 2.3-4.35L77.5-1.9z"
                    />
                </g>
                <g id="PlaInd040__Layer2_1_MEMBER_1_FILL">
                    <path
                        fill="url(#PlaInd040__Gradient_14)"
                        d="M67.55 106q-4.45 4.9-9.95 13.15-14.5 22.05-27.95 55.5-.5 1.25-1 2.45-.9 2.2-1.7 4.4-6.9 17.75-11.25 33.25-.05.15-.1.25l38.85-.6q.05-.1.2-.25 2.6-5.7 5.25-11.75 2.5-5.9 4.95-12.15.5-1.2 1-2.45 13-33.55 17.45-59.3.5-2.9.85-5.55l.7-13.3q-.1-1.4-.25-2.65-.85-6.6-4.4-7.9-4.8-1.75-12.65 6.9z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_15)"
                        d="M248.2 123.7q-.9 2.8-1.5 6.25l-1.4 13.3q-.3 6.85.05 14.2l3.5 29.35q1.6 9.35 4.05 19.35.3 1.35.65 2.7.65 2.7 1.45 5.4 0 .15.05.25h57.05q0-.1-.05-.25-.7-3.7-1.45-7.45-.5-1.9-.9-3.85-.95-4.1-2.05-8.35-.35-1.35-.65-2.65-9.3-35.4-23.45-58.75-3.65-6.15-7.2-10.55-10.25-12.9-18.65-10.7-6.3 1.7-9.4 11.5-.05.15-.1.25z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_16)"
                        d="M179.75 134.3q-5.75-11.65-14.5-12.65-8.95-1.05-17.5 9.65-.65.75-1.25 1.55-3.95 5.25-7.85 13-12.45 24.9-17 61.3-.3 1.35-.45 2.7-.3 2.2-.4 4.4-.05.15-.05.25h67.2q0-.1.05-.25 3.75-36.1-2.45-62.95-2.45-10.3-5.8-17z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_17)"
                        d="M352.3 90.6q-.6-.45-1.15-.85-6.8-5-10.6-2.9-2.35 1.3-3.05 5.2-1.15 6.7 2.85 21.15 6.1 21.9 20.8 49.25.5 1 1.05 2 .7 1.35 1.6 3 3.8 6.8 10.35 18.45.1.2.25.45 3.7 6.55 9.1 19.4-.258-1.435-.45-2.25l4.9 9.85v-79.4q-12.65-18.8-25.3-33.15-5.9-6.6-10.35-10.2z"
                    />
                </g>
                <g id="PlaInd040__Layer1_2_FILL">
                    <path
                        fill="url(#PlaInd040__Gradient_19)"
                        d="M311.9 344.65q-9.8-3.95-22.45-3.95-16.3 0-27.85 6.65-11.5 6.45-11.5 15.7 0 8.2 9.1 14.2 1.15.8 2.4 1.45 3.65 2.1 7.8 3.55l2.25.7q7.6 2.35 16.9 2.35h.9l3.5-.1q14.05-.65 24.3-6.5 11.55-6.4 11.55-15.65t-11.55-15.7q-2.55-1.5-5.35-2.7z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_20)"
                        d="M229.7 295.8q-8.05-4.7-19.45-4.7-11.35 0-19.45 4.7-8 4.7-8 11.35 0 6.55 8 11.25 8.1 4.7 19.45 4.7 11.4 0 19.45-4.7 8.05-4.7 8.05-11.25 0-6.65-8.05-11.35z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_21)"
                        d="M189.3 271.45q0 3.25 4.75 5.65 4.8 2.3 11.5 2.3t11.45-2.3q4.75-2.4 4.75-5.65 0-3.35-4.75-5.7t-11.45-2.35q-6.7 0-11.5 2.35-4.75 2.35-4.75 5.7z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_22)"
                        d="M170.4 237.85q0 .8.6 1.5.8.9 2.65 1.65 2.5 1 5.75 1.25 1 .1 2.1.1 4.6 0 7.85-1.35 1.9-.75 2.7-1.65.55-.7.55-1.5 0-1.85-3.25-3.15-3.25-1.25-7.85-1.25-1.1 0-2.1.05-3.25.2-5.75 1.2-3.25 1.3-3.25 3.15z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_23)"
                        d="M218.85 244.65q0-1.85-3.25-3.15-3.25-1.25-7.85-1.25-1.1 0-2.1.05-3.25.2-5.75 1.2-3.25 1.3-3.25 3.15 0 .8.6 1.5.8.9 2.65 1.65 2.5 1 5.75 1.25 1 .1 2.1.1 4.6 0 7.85-1.35 1.9-.75 2.7-1.65.55-.7.55-1.5z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_24)"
                        d="M267.2 258.1q0-3.1-4.6-5.35-4.55-2.2-11-2.2t-11.05 2.2Q236 255 236 258.1q0 .9.4 1.8.95 1.95 4.15 3.55 4.6 2.2 11.05 2.2 6.45 0 11-2.2 3.25-1.6 4.2-3.55.4-.9.4-1.8z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_25)"
                        d="M270.8 285.55q-7.45 4.3-7.45 10.3 0 5.95 7.45 10.15 7.55 4.25 18.1 4.25 10.65 0 18.1-4.25 7.55-4.2 7.55-10.15 0-6-7.55-10.3-7.45-4.2-18.1-4.2-10.55 0-18.1 4.2z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_26)"
                        d="M258.85 232.65q-1.85-.75-4.15-1.05-1.7-.25-3.7-.25-1.1 0-2.1.05-.9.05-1.75.2-2.2.3-4 1.05-3.25 1.25-3.25 3.1 0 .8.6 1.5.8.9 2.65 1.65 2.5 1 5.75 1.25 1 .1 2.1.1 4.6 0 7.85-1.35 1.9-.75 2.7-1.65.55-.7.55-1.5 0-1.85-3.25-3.1z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_27)"
                        d="M293.8 246.15q.55-.7.55-1.5 0-1.85-3.25-3.15-3.25-1.25-7.85-1.25-1.1 0-2.1.05-3.25.2-5.75 1.2-3.25 1.3-3.25 3.15 0 .8.6 1.5.8.9 2.65 1.65 2.5 1 5.75 1.25 1 .1 2.1.1 4.6 0 7.85-1.35 1.9-.75 2.7-1.65z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_28)"
                        d="M301.6 231.6q-2.2.3-4 1.05-3.25 1.25-3.25 3.1 0 .4.15.8.15.35.45.7.8.9 2.65 1.65 2.5 1 5.75 1.25 1 .1 2.1.1H306.1q4.2-.1 7.2-1.35 1.9-.75 2.7-1.65.55-.7.55-1.5 0-1.05-1-1.9-.8-.65-2.25-1.2-.5-.2-1.05-.35-1.45-.5-3.1-.7-1.75-.25-3.7-.25-1.1 0-2.1.05-.9.05-1.75.2z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_29)"
                        d="M159.3 347.2q0 1.15.2 2.25 1.15 6.75 9.65 11.7 5.3 3.1 11.75 4.55L193 367h.25q9.95 0 17.7-3l2.5-1.05q1.75-.85 3.35-1.8 8.55-4.95 9.75-11.7.2-1.1.2-2.25 0-8.15-9.95-14-9.85-5.8-23.8-5.8-13.95 0-23.85 5.8-9.85 5.85-9.85 14z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_30)"
                        d="M155.1 384.1q-1.25 1.35-2.25 2.9-.45.7-.85 1.45h101.1q-.4-.75-.85-1.45-1-1.55-2.3-2.9-3.75-4.1-10.3-7.65-3.45-1.85-7.15-3.35-13.05-5-29.95-5-21.75 0-37.15 8.35-6.55 3.55-10.3 7.65z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_31)"
                        d="M84.45 380.6q10.9 6.15 25.8 6.8l3.65.1h1q9.8 0 17.8-2.45 5.75-1.65 10.65-4.45 12.3-6.85 12.3-16.65 0-9.8-12.3-16.7-12.2-6.95-29.45-6.95t-29.45 6.95q-12.25 6.9-12.25 16.7 0 9.8 12.25 16.65z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_32)"
                        d="M75.4 382.2q-3.9-4.25-10.7-7.9-3.5-1.95-7.35-3.45-13.5-5.15-30.95-5.15-15.85 0-28.4 4.25v18.5h81.5q-.35-.9-.85-1.8-.4-.7-.9-1.45-1.05-1.6-2.35-3z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_33)"
                        d="M61.35 329.85q-7.6-4.4-17.6-5.45-3.05-.25-6.25-.25-13.9 0-23.85 5.7-9.85 5.8-9.85 13.9 0 1.75.45 3.35 1.6 6 9.4 10.5 9.95 5.8 23.85 5.8 3.2 0 6.25-.3 10-1 17.6-5.5 3.05-1.75 5.2-3.75 4.7-4.45 4.7-10.1 0-8.1-9.9-13.9z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_34)"
                        d="M63.55 316.25q0 .75.1 1.55.9 6.95 9.85 12 10 5.65 24 5.65 14.15 0 24.05-5.65 9-5.05 9.9-12 .1-.8.1-1.55 0-8-10-13.65-9.9-5.7-24.05-5.7-14 0-24 5.7-9.95 5.65-9.95 13.65z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_35)"
                        d="M12.7 284.65q-7.15 4.05-7.15 9.8 0 5.75 7.15 9.75 7.2 4.1 17.3 4.1 10.15 0 17.3-4.1 7.2-4 7.2-9.75t-7.2-9.8q-7.15-4.05-17.3-4.05-10.1 0-17.3 4.05z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_36)"
                        d="M32.05 260.1q-5 2.4-5 5.75t5 5.75q3.85 1.85 8.85 2.25 1.55.1 3.25.1 7.1 0 12.1-2.35 5-2.4 5-5.75t-5-5.75q-5-2.35-12.1-2.35-1.7 0-3.25.15-5 .4-8.85 2.2z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_37)"
                        d="M16.65 244.15q-1.1 0-2.1.05-3.25.2-5.75 1.2-3.25 1.3-3.25 3.15 0 .8.6 1.5.8.9 2.65 1.65 2.5 1 5.75 1.25 1 .1 2.1.1 4.6 0 7.85-1.35 1.9-.75 2.7-1.65.55-.7.55-1.5 0-1.85-3.25-3.15-3.25-1.25-7.85-1.25z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_38)"
                        d="M42.65 246.3q1 .05 2.1.05 4.6 0 7.85-1.3 1.9-.75 2.7-1.7.55-.65.55-1.45 0-1.85-3.25-3.15-3.25-1.25-7.85-1.25h-2.1q-3.25.25-5.75 1.25-3.25 1.3-3.25 3.15 0 .8.6 1.45.8.95 2.65 1.7 2.5 1 5.75 1.25z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_39)"
                        d="M132.75 290.85l1.5.45q4 1.05 8.75 1.05h.5l2-.05q7.7-.3 13.3-3.35 6.45-3.4 6.45-8.25 0-4.9-6.45-8.3-6.3-3.45-15.3-3.45t-15.35 3.45q-6.35 3.4-6.35 8.3 0 4.85 6.35 8.25 2.15 1.15 4.6 1.9z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_40)"
                        d="M156.9 249.25q-4.55.4-8.05 2.05-4.55 2.25-4.55 5.4 0 1.3.85 2.45 1.1 1.6 3.7 2.85 3.5 1.7 8.05 2.1 1.45.1 3 .1 6.45 0 11-2.2 2.65-1.25 3.8-2.85.8-1.15.8-2.45 0-3.15-4.6-5.4-4.55-2.15-11-2.15-1.55 0-3 .1z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_41)"
                        d="M98.75 256.7q0-3.15-4.6-5.4-4.55-2.15-11-2.15-1.55 0-3 .1-4.55.4-8.05 2.05-4.55 2.25-4.55 5.4 0 1.3.85 2.45 1.1 1.6 3.7 2.85 3.5 1.7 8.05 2.1 1.45.1 3 .1 6.45 0 11-2.2 2.65-1.25 3.8-2.85.8-1.15.8-2.45z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_42)"
                        d="M86.2 244.05q1 .1 2.1.1 4.6 0 7.85-1.35 1.9-.75 2.7-1.65.55-.7.55-1.5 0-1.85-3.25-3.1-3.25-1.3-7.85-1.3-1.1 0-2.1.05-3.25.25-5.75 1.25-3.25 1.25-3.25 3.1 0 .8.6 1.5.8.9 2.65 1.65 2.5 1 5.75 1.25z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_43)"
                        d="M132.3 246.15q.55-.7.55-1.5 0-1.85-3.25-3.15-3.25-1.25-7.85-1.25-1.1 0-2.1.05-3.25.2-5.75 1.2-3.25 1.3-3.25 3.15 0 .8.6 1.5.8.9 2.65 1.65 2.5 1 5.75 1.25 1 .1 2.1.1 4.6 0 7.85-1.35 1.9-.75 2.7-1.65z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_44)"
                        d="M344.35 359.45q-15.55 8.3-15.55 20.15 0 4.7 2.45 8.85h57.2V351.2q-3.2-.2-6.5-.2-22 0-37.6 8.45z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_45)"
                        d="M375 342.6q9.35-5.2 9.5-12.6v-.2q0-7.5-9.5-12.8-9.45-5.35-22.85-5.35-13.35 0-22.9 5.35-9.45 5.3-9.45 12.8 0 6.55 7.2 11.4 1.05.7 2.25 1.4 9.55 5.3 22.9 5.3 13.4 0 22.85-5.3z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_46)"
                        d="M336.8 277.8q0 4.85 6 8.2 6 3.4 14.45 3.4 8.5 0 14.45-3.4 6.05-3.35 6.05-8.2 0-4.8-6.05-8.15-5.95-3.45-14.45-3.45-8.45 0-14.45 3.45-6 3.35-6 8.15z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_47)"
                        d="M324.55 269.5q4.8-2.4 4.8-5.7 0-3.3-4.8-5.7-4.75-2.3-11.45-2.3-6.7 0-11.5 2.3-4.7 2.4-4.7 5.7 0 3.3 4.7 5.7 4.8 2.3 11.5 2.3t11.45-2.3z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_48)"
                        d="M335.9 235.3q-3.25.25-5.75 1.25-3.25 1.25-3.25 3.1 0 .8.6 1.5.8.9 2.65 1.65 2.5 1 5.75 1.25 1 .1 2.1.1 4.6 0 7.85-1.35 1.9-.75 2.7-1.65.55-.7.55-1.5 0-1.85-3.25-3.1-3.25-1.3-7.85-1.3-1.1 0-2.1.05z"
                    />
                    <path
                        fill="url(#PlaInd040__Gradient_49)"
                        d="M372.35 245.4q-3.25-1.25-7.85-1.25-1.1 0-2.1.05-3.25.2-5.75 1.2-3.25 1.3-3.25 3.15 0 .8.6 1.5.8.9 2.65 1.65 2.5 1 5.75 1.25 1 .1 2.1.1 4.6 0 7.85-1.35 1.9-.75 2.7-1.65.55-.7.55-1.5 0-1.85-3.25-3.15z"
                    />
                </g>
            </defs>
            <use
                xlinkHref="#PlaInd040__Symbol_102_0_Layer0_0_FILL"
                transform="translate(-2 -2)"
                id="PlaInd040__col1n"
            />
            <use
                xlinkHref="#PlaInd040__Symbol_104_0_Layer0_0_FILL"
                transform="translate(4.4 228.25)"
                id="PlaInd040__col1l"
            />
            <use
                xlinkHref="#PlaInd040__Symbol_105_0_Layer0_0_FILL"
                transform="translate(25.35 253.55)"
                id="PlaInd040__col1d"
            />
            <use
                xlinkHref="#PlaInd040__Symbol_103_0_Layer0_0_FILL"
                transform="translate(-2 -2)"
                id="PlaInd040__col2n"
            />
            <use
                xlinkHref="#PlaInd040__Symbol_108_0_Layer0_0_FILL"
                transform="translate(24.9 235.5)"
                id="PlaInd040__col2l"
            />
            <use
                xlinkHref="#PlaInd040__Symbol_107_0_Layer0_0_FILL"
                transform="translate(103.05 235)"
                id="PlaInd040__col2d"
            />
            <use xlinkHref="#PlaInd040__Layer2_0_FILL" />
            <use xlinkHref="#PlaInd040__Layer2_1_FILL" />
            <use xlinkHref="#PlaInd040__Layer2_1_MEMBER_0_FILL" />
            <use xlinkHref="#PlaInd040__Layer2_1_MEMBER_1_FILL" />
            <use xlinkHref="#PlaInd040__Layer1_0_FILL" />
            <use xlinkHref="#PlaInd040__Layer1_1_FILL" />
            <use xlinkHref="#PlaInd040__Layer1_2_FILL" />
        </g></g>
    )
}
export default PlaInd040
